import { SET_ALERT_MULTIPLE } from '../../../redux/handleAlertModal/AlertModal';
import getCookie from '../getCookie';

export const handleAlertModal = ({
  dispatch,
  alertModal = true,
  modalType,
  modalTitle = '',
  modalDescription,
  modalButtonUrl = getCookie('referralName'),
}) => {
  dispatch({
    type: SET_ALERT_MULTIPLE,
    payload: {
      alertModal,
      modalType,
      modalTitle,
      modalDescription,
      modalButtonUrl,
    },
  });
};
